<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <custom-layout :view-config="customViewConfig">
          <vendor-search-box
            slot="ct_vendname"
            :label="customLabel.ct_vendname || '报备原厂'"
            placeholder="请输入或选择原厂名称"
            v-model="form.main.ct_vendname"
            @onchange="vendChange"
            @select="onSelectVendor"
          />
          <date-field
            slot="ct_date"
            :label="customLabel.ct_date || '报备日期'"
            v-model="form.main.ct_date"
          />
          <qcc-search-box
            slot="ct_custname"
            :label="customLabel.ct_custname || '客户名称'"
            placeholder="请输入或选择客户"
            v-model="form.main.ct_custname"
            ref="qccBox"
          ></qcc-search-box>
          <combo-search-box
            slot="ct_industry"
            :label="customLabel.ct_custname || '行业类型'"
            placeholder="请选择或输入行业类型"
            v-model="form.main.ct_industry"
            url="/api/document/industry/getCombo"
            ref="combo"
          />
        </custom-layout>
        <div class="weui-cells__title">报备说明</div>
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                v-model="form.main.ct_remark"
                placeholder="请输入..."
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import VendorSearchBox from "@/components/field/VendorSearchBox.vue";
import DateField from "@/components/field/DateField.vue";
import QccSearchBox from "@/components/field/QccSearchBox.vue";
import ComboSearchBox from "@/components/field/ComboSearchBox.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    VendorSearchBox,
    DateField,
    QccSearchBox,
    ComboSearchBox,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/crm/clientput",
      codeField: "ct_code",
      statusField: "ct_statuscode",
      caller: "ClientPut",
      xtype: "crm-clientput-formpanel",
      form: {
        main: {},
      },
    };
  },
  methods: {
    vendChange() {
      this.form.main.ct_venduu = null;
    },
    onSelectVendor(selection) {
      this.form.main.ct_venduu = selection.ve_uu;
    },
    industry_combo_save(ct_industry) {
      var me = this;
      let combo = me.$refs.combo.data,
        save = combo.some((item) => {
          return item.value == ct_industry;
        });
      if (!save) {
        me.$ajax({
          url: "/api/document/industry/save",
          method: "POST",
          jsonData: {
            in_name: ct_industry,
            id: 0,
          },
        }).then();
      }
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.ct_vendname) {
        me.$weui.topTips("请填写原厂", 2000);
      } else if (!main.ct_date) {
        me.$weui.topTips("请选择报备日期", 2000);
      } else if (!main.ct_custname) {
        me.$weui.topTips("请填写或选择客户名称", 2000);
      } else {
        me.form.main.ct_industry &&
          me.industry_combo_save(me.form.main.ct_industry);
        me.p_save();
      }
    },
  },
};
</script>